import { FT_SINGLE, FT_DATE } from '../FilterTypes';
import { CAT_CONTACTS } from 'App/utils/Collections';

const groups = {
  contacts: {
    name: 'Contacts',
    groupOrderIndex: 0,
  },
  general: {
    name: 'General',
    groupOrderIndex: 1,
  },
  other: {
    name: 'Other',
    groupOrderIndex: 2,
  },
  personal_data: {
    name: 'Personal Data',
    groupOrderIndex: 3,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 4,
  },
};

export default {
  category: CAT_CONTACTS,
  filters: [
    {
      id: 'id',
      label: 'ID Number',
      type: FT_SINGLE,
      group: groups.general,
      hint: '',
    },
    {
      id: 'name',
      label: 'Name',
      type: FT_SINGLE,
      group: groups.personal_data,
      hint: '',
    },
    {
      id: 'surname',
      label: 'Surname',
      type: FT_SINGLE,
      group: groups.personal_data,
      hint: '',
    },
    {
      id: 'employmentPositions.mediaResources.value',
      label: 'E-Mail',
      type: FT_SINGLE,
      group: groups.contacts,
      hint: '',
    },
    {
      id: 'employmentPositions.company.name',
      label: 'Company Name',
      type: FT_SINGLE,
      group: groups.other,
      hint: '',
    },
    {
      id: 'employmentPositions.position',
      label: 'Position',
      type: FT_SINGLE,
      group: groups.other,
      hint: '',
    },
    {
      id: 'createdAt',
      label: 'Created',
      type: FT_DATE,
      group: groups.date,
    },
  ],
  searchBarProp: 'complex_name',
};
